import { UserReview } from "./userReview.organism";

export default UserReview;
